import React, { Component } from 'react';
import autoBind from 'auto-bind';
import { loadInfoForPriceMatch } from 'actions/tools/DecisionTree/DiscountActions';
import { setSelectedDiscountPeriod } from 'actions/searchActions';
import {
  getCurrentDecisionNodeContent,
  getDecisionNodeAtPath,
  getSimplrAccountIdOfSelectedTicket,
  getDiscountPeriods,
  getSelectedDiscountPeriod,
} from 'extractFromState';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import SearchDropDown from 'components/DropDown/SearchDropDown/SearchDropDown';
import { returnToPreviousMacroWizardPath, setDiscountPeriods } from 'actions/searchActions';
import { getSelectedLineItems, getOrderingSystem } from 'selectors/tools';
import { getDiscountPeriodsForAccount } from 'api/partner';
import { getDiscountPeriodFields } from 'util/formatUtil';
import { showErrorPopup } from 'components/popups/ErrorPopup/ErrorPopup';
import { NextButton, BackButton } from 'components/common/buttonsComponents';
import {
  Container,
  InnerContainer,
  Title,
  SubTitle,
  SubText,
  Instructions,
  InstructionsSection,
  RadioButtonContainer,
  RadioButton,
  RadioButtonLabel,
} from './DTSelectDiscountPeriodNode.styles';
import { ActionsButtonsWrapper } from '../../DecisionTree.styles';

export class DTSelectDiscountPeriodNode extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      loading: false,
      confirmed: false,
    };
  }

  async UNSAFE_componentWillMount() {
    // clears selected period on each pass
    this.props.setSelectedDiscountPeriod(null);
    try {
      const discountPeriodsObjects = await getDiscountPeriodsForAccount(this.props.selectedSimplrAccountId);
      const discountPeriods = getDiscountPeriodFields(discountPeriodsObjects);
      this.props.setDiscountPeriods(discountPeriods);
    } catch (err) {
      showErrorPopup(`There was a problem loading this partner's data`, 'Error');
    }
  }

  async nextButtonAction() {
    this.setState({ loading: true });
    await this.props.loadInfoForPriceMatch();
    this.setState({ loading: false });
  }

  backButtonAction() {
    this.props.returnToPreviousMacroWizardPath();
  }

  handleSelectDiscountPeriod(discObj) {
    let newValue;
    if (discObj) {
      // set the item id to the discount record - in none found, set to false
      newValue =
        discObj.value === 'none'
          ? { title: 'none' }
          : this.props.discountPeriods.find((period) => discObj.value === period.objectId) || false;
    } else {
      newValue = null;
    }
    this.props.setSelectedDiscountPeriod(newValue);
  }

  getCurrentDiscountPeriodOptions() {
    const out = this.props.discountPeriods.map((period) => ({
      value: period.objectId,
      label: period.title,
    }));

    return [...out, { value: 'none', label: 'No discount is applicable' }];
  }

  getSelectedDiscountDropdownOption() {
    const { selectedDiscountPeriod } = this.props;
    // get the data for the dropdown
    if (this.props.selectedDiscountPeriod) {
      if (selectedDiscountPeriod.title !== 'none') {
        return this.getCurrentDiscountPeriodOptions().find(
          (option) => option.value === selectedDiscountPeriod.objectId
        );
      }

      return 'none';
    }

    return false;
  }

  noDiscountApplicableSelected() {
    return this.props.selectedDiscountPeriod && this.props.selectedDiscountPeriod.title === 'none';
  }

  selectedDiscountPeriodHasNoInstructions() {
    return (
      this.props.selectedDiscountPeriod &&
      this.props.selectedDiscountPeriod.title === 'none' &&
      !this.props.selectedDiscountPeriod.discountQualificationInstructions
    );
  }

  displayInstructions() {
    return (
      this.getSelectedDiscountDropdownOption() &&
      !this.noDiscountApplicableSelected() &&
      this.props.selectedDiscountPeriod.discountQualificationInstructions
    );
  }

  nextButtonEnabled() {
    if (this.displayInstructions()) {
      return this.state.confirmed && !this.state.loading;
    } else if (this.selectedDiscountPeriodHasNoInstructions()) {
      return true;
    }

    return this.getSelectedDiscountDropdownOption() && !this.state.loading;
  }

  render() {
    const { content, selectedDiscountPeriod } = this.props;

    return (
      <Container>
        <InnerContainer>
          <Title>{content.title}</Title>
          <SubTitle>{content.subText}</SubTitle>
          <SearchDropDown
            selectedId={this.getSelectedDiscountDropdownOption()}
            options={this.getCurrentDiscountPeriodOptions()}
            placeholder={'Select a discount period'}
            onChange={(obj) => this.handleSelectDiscountPeriod(obj)}
            center={true}
          />
          {this.noDiscountApplicableSelected() && (
            <InstructionsSection>
              <SubText>
                You have indicated that none of the available discounts apply. Click next to confirm your choice.
              </SubText>
            </InstructionsSection>
          )}
          {this.displayInstructions() && (
            <InstructionsSection>
              <Title>
                Here is a description of the discount you selected. Please make sure the item the customer is inquiring
                about fits this description.
              </Title>
              <Instructions>{selectedDiscountPeriod.discountQualificationInstructions}</Instructions>
              <RadioButtonContainer>
                <SubText>Do you feel item the customer is asking about qualifies for this discount?</SubText>
                <RadioButton type="radio" onClick={() => this.setState({ confirmed: true })} />
                <RadioButtonLabel for="percentage">Yes</RadioButtonLabel>
                <RadioButton
                  type="radio"
                  onClick={() => {
                    this.setState({ confirmed: false });
                    this.props.setSelectedDiscountPeriod({ title: 'none' });
                  }}
                />
                <RadioButtonLabel for="percentage">No</RadioButtonLabel>
              </RadioButtonContainer>
            </InstructionsSection>
          )}
        </InnerContainer>
        <ActionsButtonsWrapper>
          <NextButton
            active={this.nextButtonEnabled()}
            disabled={!this.nextButtonEnabled()}
            type="submit"
            onClick={() => this.nextButtonAction()}
          >
            NEXT
          </NextButton>
          <BackButton onClick={() => this.backButtonAction()}>BACK</BackButton>
        </ActionsButtonsWrapper>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    content: getCurrentDecisionNodeContent(state),
    decisionNode: getDecisionNodeAtPath(state),
    selectedLineItems: getSelectedLineItems(state),
    orderingSystem: getOrderingSystem(state),
    selectedSimplrAccountId: getSimplrAccountIdOfSelectedTicket(state),
    discountPeriods: getDiscountPeriods(state),
    selectedDiscountPeriod: getSelectedDiscountPeriod(state),
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators(
      {
        setDiscountPeriods,
        returnToPreviousMacroWizardPath,
        setSelectedDiscountPeriod,
        loadInfoForPriceMatch,
      },
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DTSelectDiscountPeriodNode);
